import { render } from "./CFooter.vue?vue&type=template&id=e9d45e34&scoped=true"
const script = {}

import "./CFooter.vue?vue&type=style&index=0&id=e9d45e34&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e9d45e34"]])

export default __exports__